<template>
  <div class="lostpassword">
    <brave-form v-bind="form" :validate="validate" :sending="awaitingResponse">
      <md-card class="md-flex-100 md-flex-small-100">

        <md-card-header>
          <div class="md-title">Lost Password</div>
          <p class="lead">If you have lost your password don't worry.  Just follow the instructions below and you'll be up and running in no time.</p>
          <p>Enter the email address currently listed in your Member account.  We will send you a link which will allow you to reset your password. <br/><br />It will take a few moments to process your request.</p>
          <div class="error-container" v-for="(hasError, error) in errors">
            <div v-if="hasError" v-html="$t(`login.ERROR_${error.toUpperCase()}`)"></div>
          </div>
          <div v-if="emailSuccessMessage" class="success-message">
            {{emailSuccessMessage}}
          </div>

        </md-card-header>
        <md-card-content>
          <div class="md-layout-row md-layout-wrap md-gutter">
            <div class="md-flex md-flex-small-100">
              <md-field :class="getValidationClass('email')">
                <label for="email">Your Email</label>
                <md-input name="email" id="email" v-model="form.email" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.email.required">Your email address is required</span>
                <span class="md-error" v-else-if="!$v.form.email.minlength">Invalid email address</span>
              </md-field>
            </div>
          </div>
        </md-card-content>
        <md-card-actions>
          <md-button
            type="submit"
            class="md-accent md-raised"
            :disabled="sending">Reset Password</md-button>
        </md-card-actions>


      </md-card>
      <div class="helper-links">

        <template v-if="asModal == true">
          <a class="accent" @click="swapToRegister">Need an account?</a>
          <a class="accent" @click="swapToLogin">Remember your password?</a>
        </template>
        <template v-else>
          <router-link class="accent" :to="{path: '/register', query}">Need an account?</router-link>
          <router-link class="accent" :to="{path: '/login', query}">Remember your password?</router-link>
        </template>
      </div>

    </brave-form>
  </div>
</template>

<script>
  import Vue from 'vue'
  import QueryString from 'brave-utils/query-string'
  import FormExtension from 'brave-form/components/extension'
  import BravenetAPI from 'brave-api/bravenet'
  import style from 'brave-authentication/components/login-register.scss'
  import securityUpgrade from 'brave-authentication/components/security-upgrade'
  import register from 'brave-authentication/components/register'
  import login from 'brave-authentication/components/login'
  import { validationMixin } from 'vuelidate'
  import {
    required,
    email,
    minLength,
    maxLength
  } from 'vuelidate/lib/validators'

  export default {
    extends: FormExtension,
    name: 'LostPasswordForm',

    data: () => {
      let qs = new QueryString(window.location.search)

      let params = qs.toSingleValueDict()
      let from = (params.from)
        ? params.from
        : null
      let query = (from)
        ? { from: from }
        : {}
        
      if(params.template_id!==undefined) {
        query.template_id = params.template_id
      }
      
      if(params.type!==undefined) {
        query.type = params.type
      }
      

      return {
        form: {
          email: null
        },
        emailSuccessMessage: null,
        errors: {
          cookie: false,
          unexpected: false,
          authentication: false,
          locked: false
        },
        query
              }
    },

    validations: {
      form: {
        email: {
          required,
          minLength: minLength(3)
        }
      }
    },
    methods: {
      clearForm () {
        this.form.email = null
      },
      async onSubmit () {
        for (let error of (Object.keys(this.errors))) {
          this.errors[error] = false
        }
        let data = await BravenetAPI.lostpassword(this.form)
        if (data.status === "ERROR") {
          switch (data.response.reason) {
            case 'AUTHENTICATION_FAILED':
              this.errors.authentication = true
              break;
            case 'COOKIES_REQUIRED':
              this.errors.cookie = true
              break;
            case 'ACCOUNT_LOCKED':
              this.errors.locked = true
              break;
            default:
              this.errors.unexpected = true
              break;
          }

          this.afterSubmit()
        } else if (data.status === "SUCCESS") {
          if (this.asModal) {
            this.emailSuccessMessage = data.response.message
            this.afterSubmit(true)
          } else {
            this.emailSuccessMessage = data.response.message
            this.afterSubmit(true)
          }
        } else {
          this.errors.unexpected = true
          this.afterSubmit()
        }
      },
      swapToRegister () {
        // Use props type if available, otherwise fall back to query type
        const typeToPass = this.type || this.query.type
        
        this.$store.dispatch('popModal')
        this.$store.dispatch('pushModal', {component: register, props: {onSuccess: this.onSuccess, from: this.from, template_id: this.query.template_id, type: typeToPass}})
      },
      swapToLogin () {
        // Use props type if available, otherwise fall back to query type
        const typeToPass = this.type || this.query.type
        

        
        this.$store.dispatch('popModal')
        this.$store.dispatch('pushModal', {component: login, props: {onSuccess: this.onSuccess, from: this.from, template_id: this.query.template_id, type: typeToPass}})
      }
    },
    props: ['asModal', 'onSuccess', 'from', 'template_id', 'type']
  }
</script>




// WEBPACK FOOTER //
// lib/brave-authentication/components/lostpassword.vue